var exports = {
  "D": "x234b8571--b982db--title",
};

module.exports = exports;
